'use client';
import { Box, Typography, useTheme } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from 'react-icons/md';

function PreviousAndNext({ data: blogData }) {
  const muiTheme = useTheme();
  const router = useRouter();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: !blogData?.next?.can
          ? 'flex-start'
          : !blogData?.previous?.can
            ? 'flex-end'
            : 'space-between',
        alignItems: { xs: 'normal', md: 'center' },
        mb: 12,
        width: { xs: '100%', md: '90%' },
        mx: 'auto',
        gap: { xs: 4, md: 0 },
      }}>
      {blogData?.previous?.can && (
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 1, md: 2 },
            alignItems: 'center',
            maxWidth: { xs: '100%', md: '300px', lg: '400px' },
          }}>
          <Box>
            <MdKeyboardDoubleArrowRight
              style={{ cursor: 'pointer', width: '30px', height: '30px' }}
              color={muiTheme.palette?.primary?.dark}
              onClick={() =>
                router.push(`/blog/${blogData?.previous?.shortId}`)
              }
            />
          </Box>
          <Image
            style={{
              borderRadius: '50%',
              cursor: 'pointer',
              objectPosition: 'center',
              objectFit: 'cover',
            }}
            src={blogData?.previous?.cover}
            alt={blogData?.previous?.title}
            onClick={() => router.push(`/blog/${blogData?.previous?.shortId}`)}
            width={80}
            loading="lazy"
            height={80}
          />
          <Box>
            <Typography
              onClick={() =>
                router.push(`/blog/${blogData?.previous?.shortId}`)
              }
              sx={{ color: 'grey.600', cursor: 'pointer' }}>
              مقاله قبلی :
            </Typography>
            <Typography
              onClick={() =>
                router.push(`/blog/${blogData?.previous?.shortId}`)
              }
              sx={{
                fontSize: '17px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
              }}>
              {blogData?.previous?.title}
            </Typography>
          </Box>
        </Box>
      )}
      {blogData?.next?.can && (
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 1, md: 2 },
            alignItems: 'center',
            direction: 'ltr',
            maxWidth: { xs: '100%', md: '300px', lg: '400px' },
          }}>
          <Box>
            {' '}
            <MdKeyboardDoubleArrowLeft
              color={muiTheme.palette?.primary?.dark}
              style={{ cursor: 'pointer', width: '30px', height: '30px' }}
              onClick={() => router.push(`/blog/${blogData?.next?.shortId}`)}
            />
          </Box>

          <Image
            style={{
              borderRadius: '50%',
              cursor: 'pointer',
              objectPosition: 'center',
              objectFit: 'cover',
            }}
            src={blogData?.next?.cover}
            alt={blogData?.next?.title}
            width={80}
            loading="lazy"
            height={80}
            onClick={() => router.push(`/blog/${blogData?.next?.shortId}`)}
          />
          <Box>
            <Typography
              onClick={() => router.push(`/blog/${blogData?.next?.shortId}`)}
              sx={{ color: 'grey.600', cursor: 'pointer' }}>
              : مقاله بعدی
            </Typography>
            <Typography
              onClick={() => router.push(`/blog/${blogData?.next?.shortId}`)}
              sx={{ fontSize: '17px', fontWeight: 600, cursor: 'pointer' }}>
              {blogData?.next?.title}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default PreviousAndNext;
